<template>
  <AppHeaderDropdown right no-caret id="notification">
    <template slot="header">
      <i @click="readNotifications()" class="icon-bell" style="color: #fff;"><span v-if="unreadCount" class="badge badge-danger">{{unreadCount}}</span></i>
    </template>\
    <template slot="dropdown">
     <b-dropdown-header
        tag="div"
        class="text-center">
        <a v-if="notifications.length > 0" href="javascript:;" @click="clearNotifications()">Remove Notifications</a>
        <span v-if="notifications.length == 0" > No notifications </span>
      </b-dropdown-header>
      <template v-for="notification in notifications">
        <b-dropdown-item :class="!notification.read_at ? 'unread' : ''"><b>{{notification.title}}</b> <br> {{notification.description}} </b-dropdown-item>
        <b-dropdown-divider />
      </template>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Models from '@/store/ORM/models.js';
import * as constants from '@/helpers/Constants.js';
import ClientService from '@/services/client.service.js';


export default {
  name: 'NotificationsDropdown',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      serverUrl : constants.serverUrl,
      notifications:[]
    }
  },
  created(){
    ClientService.setAxios();
    ClientService.getNotifications().then((res)=>{
        if(res.data.success){
          this.notifications = res.data.notifications;
          this.initNotifications();
        }else{
          this.initNotifications();
        }
      },err => {
      })

  },
  methods : {
    readNotifications(){
      ClientService.readNotifications().then((res)=>{
          if(res.data.success){
            this.notifications = res.data.notifications;
          }else{
          }
        },err => {
        })
    },
    
    initNotifications(){
      var vm = this;
      var created_at = "1991-01-01 00:00:00";
      if(this.notifications.length > 0){
        created_at = this.notifications[0].created_at;
      }
      ClientService.getNotifications(created_at).then((res)=>{
          if(res.data.success){
            if(res.data.notifications.length > 0){
              this.notifications.prepend(...res.data.notifications);
               vm.$toastr.info('There is a new Notification for you','Info!');
            }
            setTimeout(()=>{
              vm.initNotifications();
            },10000);
          }else{
          }
      },err => {
      })
    },
    clearNotifications(){
      ClientService.clearNotifications().then((res)=>{
          if(res.data.success){
            this.notifications = res.data.notifications;
          }
        },err => {
        })

    }

  },
  computed: {
    getUser(){
      return Models.Nutritionist.query().first();
    },
    unreadCount(){
        let unread = 0;
        this.notifications.forEach((notif)=>{
          if(!notif.read_at){
            unread++;
          }
        });
        return unread;
      }
    }
}
</script>

<style>
ul.dropdown-menu{
  columns: auto;
}
.dropdown-divider{
  margin:0px !important;
}
.unread{
  background: #e4e5e6d1;
}
#notification > ul{
  max-width: 80vw;
}
</style>